import React from 'react';
import './StatCard.css';

/**
 * StatCard — Dashboard stat/metric card
 * 
 * @param {string} label - Metric label
 * @param {string|number} value - Primary value
 * @param {React.ReactNode} icon - Card icon
 * @param {'green'|'blue'|'orange'|'purple'} color - Accent color
 * @param {string} trend - Optional trend text (e.g., "+12%")
 * @param {'up'|'down'} trendDirection
 * @param {string} subtitle - Additional context
 */
const StatCard = ({
  label,
  value,
  icon,
  color = 'green',
  trend,
  trendDirection,
  subtitle,
  className = '',
  ...props
}) => {
  const classes = [
    'ck-stat-card',
    `ck-stat-card--${color}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      <div className="ck-stat-card-top">
        <div className="ck-stat-card-text">
          <span className="ck-stat-card-label">{label}</span>
          <span className="ck-stat-card-value">{value}</span>
          {subtitle && <span className="ck-stat-card-subtitle">{subtitle}</span>}
        </div>
        {icon && <div className="ck-stat-card-icon">{icon}</div>}
      </div>
      {trend && (
        <div className={`ck-stat-card-trend ck-stat-card-trend--${trendDirection || 'up'}`}>
          <span>{trend}</span>
        </div>
      )}
    </div>
  );
};

export default StatCard;
